import React from 'react';

export default ({ direction, stroke, fill }) => (
  <svg width="100%" viewBox="0 0 28 39" fill={fill || 'none'} xmlns="http://www.w3.org/2000/svg">
    <path transform={direction === 'right' ? 'scale(-1, 1) translate(-28, 0)' : ''} d="M2.56554 25.8141L24.5387 37.2401C25.2044 37.5863 26 37.1032 26 36.3529L26 2.78306C26 2.00213 25.1449 1.52256 24.4786 1.92977L9.19108 11.2721C8.6066 11.6293 8.54613 12.4551 9.07234 12.8936L14 17L2.50279 24.0752C1.84111 24.4824 1.87623 25.4556 2.56554 25.8141Z" stroke={stroke || '#242433'} strokeWidth="3" />
  </svg>
);
